document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.quantityChange === 'increase' ? 1 : -1;
        input.value = Math.max(1, Number(input.value || 1) + direction);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const featured = gallery.querySelector('[data-featured-media]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const next = thumb.querySelector('img');
        if (!next || !featured) return;
        featured.src = next.dataset.largeSrc || next.src;
        featured.alt = next.alt;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.removeAttribute('aria-current'));
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });
});
